module.exports = __webpack_public_path__ + "img/22.c85516d8.jpg";